"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
exports.getVerticalSpace = getVerticalSpace;
exports.outerSpacersPortrait = exports.outerSpacersLandscape = void 0;
var _react = require("@linaria/react");
var _breakpoints = require("./breakpoints");
var _propTypes = _interopRequireDefault(require("prop-types"));
/** @module Space */

const outerSpacersLandscape = exports.outerSpacersLandscape = {
  none: '0',
  small: 'var(--viewport-space--400)',
  // 2vw
  medium: 'var(--viewport-space--300)',
  // 4vw
  large: 'var(--viewport-space-100)' // 8vw
};
const outerSpacersPortrait = exports.outerSpacersPortrait = {
  none: '0',
  small: 'var(--fixed-space-100)',
  // 1rem
  medium: 'var(--fixed-space-500)',
  // 3rem
  large: 'var(--fixed-space-800)' // 6rem
};

/**
 * Vertical Outer Spacer
 * @example
 *
 * ```
 * import { outerSpacersLandscape } from './vertical-outer-spacing.js'
 *
 * const style = css`
 *  margin: ${outerSpacersLandscape.medium} ${outerSpacersLandscape.medium};
 * `
 * ```
 * or the preferred method:
 * ```
 * const ParentContainer = styled.section`
 *  margin-block-start: ${({ verticalMargin }) => getVerticalSpace(verticalMargin, true)};
 *  margin-block-end: ${({ verticalMargin }) => getVerticalSpace(verticalMargin, true)};
 *
 *  ~@media only screen and ${device.tablet} {
 *    margin-block-start: ${({ verticalMargin }) => getVerticalSpace(verticalMargin)};
 *    margin-block-end: ${({ verticalMargin }) => getVerticalSpace(verticalMargin)};
 *  }`;
 * ```
 *
 * @param {Object} props React props
 * @param {Boolean} portrait Mobile Spacing Condition
 * @returns {React.ReactElement} Vertical Outer Spacer Component
 * @public
 */

function getVerticalSpace(props, portrait) {
  let verticalSpace;
  switch (props) {
    case 'none':
      verticalSpace = `${outerSpacersLandscape.none}`;
      break;
    case 'small':
      verticalSpace = `${portrait ? `${outerSpacersPortrait.small}` : `${outerSpacersLandscape.small}`}`;
      break;
    case 'medium':
      verticalSpace = `${portrait ? `${outerSpacersPortrait.medium}` : `${outerSpacersLandscape.medium}`}`;
      break;
    case 'large':
      verticalSpace = `${portrait ? `${outerSpacersPortrait.large}` : `${outerSpacersLandscape.large}`}`;
      break;
    default:
      verticalSpace = `${portrait ? `${outerSpacersPortrait.small}` : `${outerSpacersLandscape.small}`}`;
      break;
  }
  return verticalSpace;
}
getVerticalSpace.propTypes = {
  props: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  portrait: _propTypes.default.bool
};

/**
 * @constant
 * @param {string} verticalMargin Vertical Outer spacing value ['none', 'small', 'medium', 'large]
 * @param {string} verticalPadding Vertical Inner spacing value ['none', 'small', 'medium', 'large]
 * @returns {void}
 */
const Layout = exports.Layout = /*#__PURE__*/(0, _react.styled)("section")({
  name: "Layout",
  class: "utils-la6fqgq",
  vars: {
    "la6fqgq-0": [({
      verticalMargin
    }) => getVerticalSpace(verticalMargin, true)],
    "la6fqgq-2": [({
      verticalPadding
    }) => getVerticalSpace(verticalPadding, true)],
    "la6fqgq-5": [({
      verticalMargin
    }) => getVerticalSpace(verticalMargin)],
    "la6fqgq-7": [({
      verticalPadding
    }) => getVerticalSpace(verticalPadding)]
  }
});